import { QueriesErrorObserver } from '@wix/premium-fed-sdk/@apis-infra-react';
import { createModuleExtension } from '@wix/premium-fed-sdk/@premium-module';
import React from 'react';
import { Notification } from './Notification/Notification';
import { NotificationProvider, useNotification } from './Notification/NotificationProvider';
import { NotificationWrapper } from './Notification/NotificationWrapper';
export const ErrorsExtension = createModuleExtension(_ref => {
  let {
    ErrorsMapper,
    notificationButtonType
  } = _ref;
  return {
    extensionName: 'ErrorsExtension',
    Provider: _ref2 => {
      let {
        children
      } = _ref2;
      return /*#__PURE__*/React.createElement(QueriesErrorObserver, {
        onError: () => {
          return true;
        },
        Error: _ref3 => {
          let {
            error
          } = _ref3;
          return /*#__PURE__*/React.createElement(ErrorsMapper, {
            error: error
          });
        }
      }, /*#__PURE__*/React.createElement(NotificationProvider, {
        buttonType: notificationButtonType
      }, /*#__PURE__*/React.createElement(NotificationWrapper, null), children));
    },
    SDK: {
      Notification,
      useNotification
    }
  };
});
//# sourceMappingURL=errors.extension.js.map